/* eslint-disable react/no-deprecated */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import StoreMallDirectoryOutlinedIcon from '@material-ui/icons/StoreMallDirectoryOutlined';
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { Divider } from '@material-ui/core';
import { HUBRISE_DOMAIN } from '../../constants/hubrise';
import { UNIT, settings } from '../../constants';
import Paper from '../Paper';
import Button from '../Button';
import Spinner from '../Spinner';
import * as actions from '../../actions/index';
import { styles } from './HubriseConfig.style';
import { connectToHubrise } from '../../apis/hubrise';
import { hubriseLogout, initializeData, showConfirmation } from './HubriseConfig.services';
import BackButton from '../BackButton';

const INITIAL_STATE = {
  isLoading: true,
  data: {}
};
class HubRiseConfig extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentWillMount() {
    initializeData(this);
  }

  componentWillReceiveProps(nextProps) {
    const { configurations = {} } = this.props;
    const { configuration = {} } = configurations;
    const { configurations: config = {} } = nextProps;
    const { configuration: oldConfig = {} } = config;
    if (!_.isEqual(configuration?.externalIntegration, oldConfig.externalIntegration))
      this.setState({
        isLoading: false
      });
  }

  render() {
    const { classes, configurations, history, sidebarCollapse } = this.props;
    const { configuration: shopConfiguration = {} } = configurations
    const { externalIntegration = {} } = shopConfiguration;
    const { configuration = {}, enabled } = externalIntegration || {};
    const { isLoading } = this.state;
    const {
      accountName,
      accountId,
      locationName,
      catalogName,
      catalogId,
      customerListName,
      customerListId,
      locationId
    } = configuration;
    return (
      <div className={`col-12 p-4 ${sidebarCollapse && 'col-lg-10'} px-0 `}>
        <>
          <BackButton
            className='p-0'
            onClick={() => history.push('/settings')}
            title={settings.hubrise.text}
            subtitle={settings.hubrise.description}
          />
          <Paper className={classes.paperStyle}>
            <div className={classes.body}>
              {!enabled && (
                <p className={classes.textStyling}>
                  Connectez vos applications à Dishop avec HubRise.
                </p>
              )}
              {enabled && (
                <div
                  className='d-sm-flex justify-content-sm-between'
                  style={{ marginBottom: UNIT * 0.625 }}
                >
                  <div
                    className={`d-flex d-sm-block align-items-center justify-content-between  justify-content-sm-center ${classes.labelText}`}
                  >
                    <div className='d-flex text-left'>
                      <AccountBalanceOutlinedIcon
                        fontSize='small'
                        className='d-none d-sm-flex mr-1'
                      />
                      Nom du compte
                    </div>
                    <p className={classes.valueStyle}>
                      {accountName} - {accountId}
                    </p>
                  </div>
                  <div
                    className={`d-flex d-sm-block align-items-center justify-content-between justify-content-sm-center ${classes.labelText}`}
                  >
                    <div className='d-flex text-left'>
                      <StoreMallDirectoryOutlinedIcon
                        fontSize='small'
                        className='d-none d-sm-flex mr-1'
                      />
                      Point de vente
                    </div>
                    <p className={classes.valueStyle}>
                      {locationName} - {locationId}
                    </p>
                  </div>
                  <div
                    className={`d-flex d-sm-block align-items-center justify-content-between justify-content-sm-center ${classes.labelText}`}
                  >
                    <div className='d-flex text-left'>
                      <LibraryBooksOutlinedIcon
                        fontSize='small'
                        className='d-none d-sm-flex mr-1'
                      />
                      Catalogue
                    </div>
                    <p className={classes.valueStyle}>
                      {catalogName} - {catalogId}
                    </p>
                  </div>

                  <div
                    className={`d-flex d-sm-block align-items-center justify-content-between justify-content-sm-center ${classes.labelText}`}
                  >
                    <div className='d-flex text-left'>
                      <PeopleOutlineIcon fontSize='small' className='d-none d-sm-flex mr-1' />
                      Liste des clients
                    </div>
                    <p className={classes.valueStyle}>
                      {customerListName} - {customerListId}
                    </p>
                  </div>
                </div>
              )}
              {isLoading ? (
                <Spinner className={classes.progress} size={30} />
              ) : (
                <>
                  <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center w-100 mb-2'>
                    <div>
                      <Button
                        color={enabled ? 'primary' : 'secondary'}
                        outlined
                        className='m-2 mr-0'
                        onClick={() => {
                          enabled
                            ? window.open(`${HUBRISE_DOMAIN}/dashboard?${accountId}`)
                            : window.open(connectToHubrise(window.location.href), '_self');
                        }}
                      >
                        {enabled ? 'Accéder à HubRise' : 'Se connecter'}
                      </Button>
                    </div>
                    {enabled && (
                      <div>
                        <Button
                          color='secondary'
                          outlined
                          className='m-2'
                          onClick={() => {
                            hubriseLogout(this);
                          }}
                        >
                          Se déconnecter
                        </Button>
                      </div>
                    )}
                  </div>
                  {enabled && (
                    <>
                      <Divider />
                      <div className='d-sm-flex justify-content-sm-between mt-2 align-items-center'>
                        <p style={{ padding: 5 }}>Se synchroniser avec le menu HubRise</p>
                        <div>
                          <Button
                            color={enabled ? 'primary' : 'secondary'}
                            outlined
                            className='m-2 mr-0'
                            onClick={e => showConfirmation(this)}
                          >
                            Synchroniser
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </Paper>
        </>
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, sidebar }) {
  const { generalConfig, shop } = firebaseRealTime;
  const {
    paymentTypes,
    terminal = {},
    chatbot = {},
    mobileApp = {},
    qrcode = {},
    webapp = {}
  } = generalConfig;
  const { sidebarCollapse } = sidebar;
  return {
    configurations: shop,
    paymentTypes,
    terminal,
    chatbot,
    mobileApp,
    qrcode,
    webapp,
    sidebarCollapse
  };
}
HubRiseConfig.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(HubRiseConfig)));
